/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { pageData } from "../../container/UserGroup/constants";
import {
  GET_ALL_USER_GROUPS,
  FETCH_USERS_BY_GROUP_FAILURE,
  FETCH_USERS_BY_GROUP_REQUEST,
  FETCH_USERS_BY_GROUP_SUCCESS,
  SET_SEARCH_VALUE_OF_USER_GROUP,
} from "./types";

export const userGroupsReducerInitialState = {
  userGroups: [],
  searchValue: '',
  selectedUserGroup: {},
  pagination: {
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0
  },
  noItem: true,
  usersByGroup: [],
  page: pageData,
  loading: false,
  error: null
};

export const userGroupsReducer = (state = userGroupsReducerInitialState, action: any) => {
  switch (action.type) {
    case GET_ALL_USER_GROUPS:
      return {
        ...state,
        userGroups: action.usersGroupsResponse.data,
        pagination: action.usersGroupsResponse.metadata,
        noItem: false
      }
    case SET_SEARCH_VALUE_OF_USER_GROUP:
      return {
        ...state,
        searchValue: action.searchValue
      }
    case FETCH_USERS_BY_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_USERS_BY_GROUP_SUCCESS:
      return {
        ...state,
        usersByGroup: action.usersByGroup,
        page: action.page,
        loading: false,
        error: null
      };

    case FETCH_USERS_BY_GROUP_FAILURE:
      return {
        ...state,
        usersByGroup: [],
        page: pageData,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}